(function (window, $) {
    'use strict';

    const checkoutModules = window.TlpCheckoutModules = window.TlpCheckoutModules || {};
    const eventNamespace = 'lpCheckoutCoupon';

    const couponSelectors = {
        input: '#custom_coupon_code',
        button: '.apply-custom-coupon',
        remove: '.woocommerce-remove-coupon',
        message: '.coupon-message',
        form: '.coupon-form'
    };

    checkoutModules.coupon = {
        init() {
            this.bindNativeClickCapture();
            this.bindNativeSubmitCapture();
            this.bindEvents();
            this.refreshButtonStates();
        },

        bindNativeClickCapture() {
            if (typeof document === 'undefined' || this.nativeClickCaptureBound) {
                return;
            }

            if (!this.nativeClickCaptureHandler) {
                this.nativeClickCaptureHandler = (event) => {
                    const button = event.target && typeof event.target.closest === 'function'
                        ? event.target.closest(couponSelectors.button)
                        : null;

                    if (!button) {
                        return;
                    }

                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();

                    const $button = $(button);
                    if ($button.is(':disabled')) {
                        return;
                    }

                    this.apply($button);
                };
            }

            document.addEventListener('click', this.nativeClickCaptureHandler, true);
            this.nativeClickCaptureBound = true;
        },

        bindNativeSubmitCapture() {
            if (typeof document === 'undefined') {
                return;
            }

            if (!this.nativeSubmitCaptureHandler) {
                this.nativeSubmitCaptureHandler = (event) => {
                    const submitContext = this.getCouponSubmitContext(event);
                    if (!submitContext) {
                        return;
                    }

                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();

                    if (submitContext.$button.length && !submitContext.$button.is(':disabled')) {
                        submitContext.$button.trigger('click');
                    }
                };
            }

            document.querySelectorAll('form.checkout, form.woocommerce-checkout').forEach((form) => {
                if (form.dataset.lpCouponSubmitCaptureBound === '1') {
                    return;
                }

                form.addEventListener('submit', this.nativeSubmitCaptureHandler, true);
                form.dataset.lpCouponSubmitCaptureBound = '1';
            });
        },

        bindEvents() {
            $(document)
                .off(`input.${eventNamespace} change.${eventNamespace}`, couponSelectors.input)
                .on(`input.${eventNamespace} change.${eventNamespace}`, couponSelectors.input, (e) => {
                    this.updateButtonState($(e.currentTarget).closest(couponSelectors.form));
                })
                .off(`keydown.${eventNamespace}`, couponSelectors.input)
                .on(`keydown.${eventNamespace}`, couponSelectors.input, (e) => {
                    if (e.key !== 'Enter') {
                        return;
                    }

                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();

                    $(e.currentTarget)
                        .closest(couponSelectors.form)
                        .find(couponSelectors.button)
                        .first()
                        .trigger('click');
                })
                .off(`click.${eventNamespace}`, couponSelectors.button)
                .on(`click.${eventNamespace}`, couponSelectors.button, (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();

                    const $button = $(e.currentTarget);
                    if ($button.is(':disabled')) {
                        return;
                    }

                    this.apply($button);
                })
                .off(`submit.${eventNamespace}`, 'form.checkout, form.woocommerce-checkout')
                .on(`submit.${eventNamespace}`, 'form.checkout, form.woocommerce-checkout', (e) => {
                    const submitContext = this.getCouponSubmitContext(e);
                    if (!submitContext) {
                        return;
                    }

                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();

                    if (submitContext.$button.length && !submitContext.$button.is(':disabled')) {
                        submitContext.$button.trigger('click');
                    }
                });

            $(document.body)
                .off(`click.${eventNamespace}`, couponSelectors.remove)
                .on(`click.${eventNamespace}`, couponSelectors.remove, (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();

                    this.remove($(e.currentTarget));
                })
                .off(`keydown.${eventNamespace}`, couponSelectors.remove)
                .on(`keydown.${eventNamespace}`, couponSelectors.remove, (e) => {
                    if (e.key !== ' ' && e.key !== 'Enter') {
                        return;
                    }

                    e.preventDefault();
                    $(e.currentTarget).trigger('click');
                })
                .off(`updated_checkout.${eventNamespace}`)
                .on(`updated_checkout.${eventNamespace}`, () => {
                    this.bindNativeClickCapture();
                    this.bindNativeSubmitCapture();
                    this.refreshButtonStates();
                })
                .off(`checkout_error.${eventNamespace}`);
        },

        getCouponSubmitContext(event) {
            const nativeEvent = event && event.originalEvent ? event.originalEvent : event;
            const submitter = nativeEvent && nativeEvent.submitter ? nativeEvent.submitter : null;
            const activeElement = typeof document !== 'undefined' ? document.activeElement : null;
            const $scope = $(submitter || activeElement).closest(couponSelectors.form);

            if (!$scope.length) {
                return null;
            }

            return {
                $scope,
                $button: $scope.find(couponSelectors.button).first()
            };
        },

        getAjaxModule() {
            return checkoutModules.ajax || {};
        },

        setMessage($scope, message, type = 'info') {
            const $message = $scope.find(couponSelectors.message).first();
            if (!$message.length) {
                return;
            }

            const colors = {
                info: '#666',
                success: '#23A455',
                error: 'rgb(255, 191, 0)'
            };

            $message
                .text(message)
                .css('color', colors[type] || colors.info)
                .show();
        },

        updateButtonState($scope) {
            const $input = $scope.find(couponSelectors.input).first();
            const $button = $scope.find(couponSelectors.button).first();
            if (!$input.length || !$button.length) {
                return;
            }

            const hasValue = String($input.val() || '').trim().length > 0;
            $button.prop('disabled', !hasValue);
            $button.toggleClass('active', hasValue);
        },

        refreshButtonStates() {
            $(couponSelectors.form).each((index, element) => {
                const $scope = $(element);
                const $button = $scope.find(couponSelectors.button).first();

                if ($button.length) {
                    $button.attr('type', 'button');
                }

                this.updateButtonState($scope);
            });
        },

        apply($button) {
            const $scope = $button.closest(couponSelectors.form);
            if (!$scope.length) {
                return;
            }

            const $input = $scope.find(couponSelectors.input).first();
            if (!$input.length) {
                return;
            }

            const code = String($input.val() || '').trim();
            if (!code) {
                this.updateButtonState($scope);
                return;
            }

            if ($button.data('isApplying') === true) {
                return;
            }

            const ajaxModule = this.getAjaxModule();

            this.setMessage($scope, 'Applying coupon...', 'info');
            $button.data('isApplying', true);
            $button.prop('disabled', true);

            const formData = new FormData();
            formData.append('action', 'apply_custom_coupon');
            formData.append('coupon_code', code);
            formData.append(
                'security',
                typeof ajaxModule.getApplyCouponNonce === 'function' ? ajaxModule.getApplyCouponNonce() : ''
            );

            fetch(
                typeof ajaxModule.getAjaxUrl === 'function' ? ajaxModule.getAjaxUrl() : '/wp-admin/admin-ajax.php',
                {
                    method: 'POST',
                    body: formData,
                    credentials: 'same-origin'
                }
            )
                .then((res) => res.json())
                .then((response) => {
                    if (response && response.success) {
                        const successMessage = (
                            response.data
                            && typeof response.data.message === 'string'
                            && response.data.message.trim() !== ''
                        ) ? response.data.message : 'Coupon applied successfully!';

                        this.setMessage($scope, successMessage, 'success');
                        $(document.body).trigger('update_checkout');
                        this.updateButtonState($scope);
                        return;
                    }

                    const errorMessage = typeof ajaxModule.getCouponErrorMessage === 'function'
                        ? ajaxModule.getCouponErrorMessage(response)
                        : 'Invalid or expired coupon.';

                    this.setMessage($scope, errorMessage, 'error');
                    this.updateButtonState($scope);
                })
                .catch(() => {
                    this.setMessage($scope, 'Error applying coupon.', 'error');
                    this.updateButtonState($scope);
                })
                .finally(() => {
                    $button.removeData('isApplying');
                });
        },

        remove($link) {
            if (!$link.length || $link.data('isRemoving') === true) {
                return;
            }

            const coupon = String($link.data('coupon') || '').trim();
            if (!coupon) {
                return;
            }

            if (
                typeof window.wc_checkout_params === 'undefined'
                || !window.wc_checkout_params.wc_ajax_url
                || !window.wc_checkout_params.remove_coupon_nonce
            ) {
                window.location.href = $link.attr('href');
                return;
            }

            const $container = $link.closest('.woocommerce-checkout-review-order');
            const $scope = $(couponSelectors.form).first();

            $link.data('isRemoving', true);

            if ($container.length && typeof $container.block === 'function') {
                $container.addClass('processing').block({
                    message: null,
                    overlayCSS: {
                        background: '#fff',
                        opacity: 0.6
                    }
                });
            }

            $.ajax({
                type: 'POST',
                url: window.wc_checkout_params.wc_ajax_url.toString().replace('%%endpoint%%', 'remove_coupon'),
                data: {
                    security: window.wc_checkout_params.remove_coupon_nonce,
                    coupon
                },
                dataType: 'html'
            })
                .done(() => {
                    if ($scope.length) {
                        this.setMessage($scope, 'Coupon removed.', 'success');
                    }

                    $(document.body).trigger('removed_coupon_in_checkout', [coupon]);
                    $(document.body).trigger('update_checkout', {
                        update_shipping_method: false
                    });
                })
                .fail(() => {
                    if ($scope.length) {
                        this.setMessage($scope, 'Error removing coupon.', 'error');
                    }
                })
                .always(() => {
                    if ($container.length && typeof $container.unblock === 'function') {
                        $container.removeClass('processing').unblock();
                    }

                    $link.removeData('isRemoving');
                });
        }
    };
})(window, jQuery);
